import { FooterSocialLink } from '../../ads-footer.types';
import { FunctionalComponent, VNode, h } from '@stencil/core';
import { Icon, SVGIcon, SVGIconData, getIconObject, getSVGIconObject } from '../../../core/interfaces/Icon';
import { generateSVGImage, isNullOrUndefined } from 'utils/index';
import { getHyperLinkObject } from '../../../core/interfaces/Hyperlink';

export const AdsFooterSocialLink: FunctionalComponent<FooterSocialLink> = ({ icon, title, link }) => {
  const linkObj = getHyperLinkObject(link);
  const anchorAttributes = {
    href: linkObj?.href,
    hrefLang: linkObj?.hreflang || null,
    rel: linkObj?.rel || null,
    target: linkObj?.target || null,
    title: title || null,
    onClick: linkObj?.onClick || null,
    'data-track': 'true',
    'data-track-value': title || null,
  };

  let svgIcon: SVGIconData = undefined;
  let classIcon: string = undefined;
  const svgIconObj = getSVGIconObject(icon as SVGIcon);
  svgIcon = svgIconObj?.active;
  const iconObj = getIconObject(icon as Icon);
  classIcon = iconObj?.active;

  return (
    <li class="footer-social-link">
      <a {...anchorAttributes}>
        {(classIcon || svgIcon) && (
          <span class={classIcon && classIcon}>
            {!isNullOrUndefined(svgIcon) && generateSVGImage({ data: svgIcon.data, height: svgIcon.height, width: svgIcon.width })}
          </span>
        )}
      </a>
    </li>
  ) as VNode;
};
